// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"156":"037f75b6","834":"0853315e"}[chunkId] + ".chunk.css";
};